define('home/utils/embed',[
    'home/models/Session',
], function (
    Session
) {
    'use strict';

    // Called via embed callback, configured in template
    // that loads embed
    var onEmbedComment = function () {
        var user = Session.get().user;
        user.set({
            numPosts: user.get('numPosts') + 1,
        });
    };

    var onEmbedLoaded = function () {};

    return {
        onEmbedComment: onEmbedComment,
        onEmbedLoaded: onEmbedLoaded,
    };
});

